import { mergeAttributes, Node } from "@tiptap/core";

import { isolateNodeView, setNodeViewAttrs } from "@/editor/adapters/utils";
import { ValidationStatus } from "@/api";

import { Props as ValidationUrlProps } from "./";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    nwValidationUrl: {
      setValidationUrl: (attributes?: ValidationUrlProps) => ReturnType;
    };
  }
}

export const NWValidationUrlAdapter = Node.create<ValidationUrlProps>({
  name: "nwValidationUrl",
  group: "block",
  atom: true,
  draggable: false,
  selectable: false,

  addAttributes() {
    return {
      id: {
        default: undefined,
        parseHTML: element => element.getAttribute("id"),
      },
      title: {
        default: "",
        parseHTML: element => element.getAttribute("title"),
      },
      description: {
        default: "",
        parseHTML: element => element.getAttribute("description"),
      },
      "help-text": {
        default: "",
        parseHTML: element => element.getAttribute("help-text"),
      },
      extension: {
        default: "https://",
        parseHTML: element => element.getAttribute("extension"),
      },
      disabled: {
        default: undefined,
        parseHTML: element => element.getAttribute("disabled"),
      },
      error: {
        default: undefined,
        parseHTML: element => element.getAttribute("error"),
      },
      data: {
        default: undefined,
        parseHTML: element => element.getAttribute("data") || undefined,
      },
      status: {
        default: ValidationStatus.Incomplete,
      },
      optional: {
        default: false,
        parseHTML: element => element.getAttribute("optional") === "true",
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "nw-validation-url",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["nw-validation-url", mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return ({ node }) => {
      const dom = document.createElement("nw-validation-url");

      setNodeViewAttrs(dom, node.attrs);

      return isolateNodeView({
        dom,
      });
    };
  },

  addCommands() {
    return {
      setValidationUrl:
        attributes =>
        ({ commands }) => {
          return commands.setNode(this.name, attributes);
        },
    };
  },
});
